import { logFilterEvent } from "./actions";

const defaultState = {
  loading: null,
  graphdata: [],
  result: "test",
  currentTab: 0,
  currentPhase: 0,
  activeQuestion: "",
  pieData: [],
  aboutSurvey: { HQContinentCount: [] },
  financialImpact: {},
  pandemicPreparedness: {},
  vaccination: {},
  wellBeing: {},
  pandemicResponse: {
    currentTab: 0,
    comeBack: {},
    adjustments: {},
    remotework: {},
  },
  contactTracing: {
    currentTab: 0,
    overview: {},
    protocols: {},
    providers: {},
  },
  testing: {
    currentTab: 0,
    overview: {},
    viral: {},
    antibody: {},
  },
  futureofwork: {
    currentTab: 0,
    overview: {},
    challenges: {},
    remotework: {},
    comingback: {},
  },
  facilitiesSafety: {},
  filterQuestions: [],
  filters: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "SIMPLE_ACTION":
      return { ...state, result: action.payload };
    case "SET_CURRENT_PHASE":
      return {
        ...state,
        filters: {},
        currentPhase: action.payload,
        activeQuestion:
          action.resetQuestion === true ? "" : state.activeQuestion,
      };
    case "SET_CURRENT_TAB":
      return {
        ...state,
        pandemicResponse: {...state.pandemicResponse, currentTab: 0},
        contactTracing: {...state.contactTracing, currentTab: 0},
        testing: {...state.testing, currentTab: 0},
        futureofwork: {...state.futureofwork, currentTab: 0},
        currentTab: action.payload,
        activeQuestion:
          action.resetQuestion === true ? "" : state.activeQuestion,
      };
    case "SET_CONTACT_TRACING_SUBTAB":
      return {
        ...state,
        contactTracing: { ...state.contactTracing, currentTab: action.payload },
        activeQuestion:
          action.resetQuestion === true ? "" : state.activeQuestion,
      };
    case "SET_PANDEMIC_RESPONSE_SUBTAB":
      return {
        ...state,
        pandemicResponse: {
          ...state.pandemicResponse,
          currentTab: action.payload,
        },
        activeQuestion:
          action.resetQuestion === true ? "" : state.activeQuestion,
      };
    case "SET_FUTUREWORK_SUBTAB":
      return {
        ...state,
        futureofwork: {
          ...state.futureofwork,
          currentTab: action.payload,
        },
        activeQuestion:
          action.resetQuestion === true ? "" : state.activeQuestion,
      };
    case "SET_TESTING_SUBTAB":
      return {
        ...state,
        testing: { ...state.testing, currentTab: action.payload },
        activeQuestion:
          action.resetQuestion === true ? "" : state.activeQuestion,
      };
    case "SET_ACTIVE_QUESTION":
      return { ...state, activeQuestion: action.payload };
    case "SET_PIE_DATA":
      return { ...state, pieData: action.payload };
    case "SET_ABOUT_SURVEY_DATA":
      return { ...state, aboutSurvey: action.payload };
    case "SET_FINANCIAL_IMPACT_DATA":
      return { ...state, financialImpact: action.payload };
    case "SET_PANDEMIC_PREPAREDNESS_DATA":
      return { ...state, pandemicPreparedness: action.payload };
    case "SET_FACILITIES_SAFETY_DATA":
      return { ...state, facilitiesSafety: action.payload };
    case "SET_VACCINATION_DATA":
      return { ...state, vaccination: action.payload };
    case "SET_WELL_BEING_DATA":
      return { ...state, wellBeing: action.payload };
    case "SET_COMEBACK_DATA":
      return {
        ...state,
        pandemicResponse: {
          ...state.pandemicResponse,
          comeBack: action.payload,
        },
      };
    case "SET_CONTACTTRACING_OVERVIEW_DATA":
      return {
        ...state,
        contactTracing: {
          ...state.contactTracing,
          overview: action.payload,
        },
      };
    case "SET_CONTACTTRACING_PROTOCOLS_DATA":
      return {
        ...state,
        contactTracing: {
          ...state.contactTracing,
          protocols: action.payload,
        },
      };
    case "SET_CONTACTTRACING_PROVIDERS_DATA":
      return {
        ...state,
        contactTracing: {
          ...state.contactTracing,
          providers: action.payload,
        },
      };
    case "SET_ADJUSTMENTS_DATA":
      return {
        ...state,
        pandemicResponse: {
          ...state.pandemicResponse,
          adjustments: action.payload,
        },
      };
    case "SET_REMOTEWORK_DATA":
      return {
        ...state,
        pandemicResponse: {
          ...state.pandemicResponse,
          remotework: action.payload,
        },
      };
    case "SET_OVERVIEW_DATA":
      return {
        ...state,
        testing: {
          ...state.testing,
          overview: action.payload,
        },
      };
    case "SET_VIRAL_DATA":
      return {
        ...state,
        testing: {
          ...state.testing,
          viral: action.payload,
        },
      };
    case "SET_ANTIBODY_DATA":
      return {
        ...state,
        testing: {
          ...state.testing,
          antibody: action.payload,
        },
      };
    case "SET_FUTUREWORK_OVERVIEW_DATA":
      return {
        ...state,
        futureofwork: {
          ...state.futureofwork,
          overview: action.payload,
        },
      };
    case "SET_FUTUREWORK_COMEBACK_DATA":
      return {
        ...state,
        futureofwork: {
          ...state.futureofwork,
          comeBack: action.payload,
        },
      };
    case "SET_FUTUREWORK_REMOTE_DATA":
      return {
        ...state,
        futureofwork: {
          ...state.futureofwork,
          remotework: action.payload,
        },
      };
    case "SET_CHALLENGES_DATA":
      return {
        ...state,
        futureofwork: {
          ...state.futureofwork,
          challenges: action.payload,
        },
      };
    case "REMOVE_ALL_FILTERS":
      return { ...state, filters: {} };
    case "REMOVE_FILTERS":
      let newfilters = Object.assign({}, state.filters);
      delete newfilters[action.payload];
      return { ...state, filters: newfilters };
    case "SET_FILTERS":
      let updatedfilters = Object.assign({}, state.filters);
      if (action.payload.value === "") {
        delete updatedfilters[action.payload.name];
      } else {
        updatedfilters[action.payload.name] = action.payload.value;
      }
      logFilterEvent(updatedfilters, state.currentPhase);
      return { ...state, filters: updatedfilters };
    case "SET_FILTER_QUESTIONS":
      return { ...state, filterQuestions: action.payload };
    default:
      return state;
  }
};
